import React from 'react';
import {Shift} from '@gakki/api/types';
import {CustomIconButton} from '@common/components/Button';
import InfoTip, {P} from '@gakki/components/info-tip/info-tip';
import cx from 'classnames';
import {ReactComponent as Warning} from '@gakki/assets/warning.svg';

type ShiftItemProps = {
  item: Shift;
  idx: number;
  onRemove: (id: string) => void;
  onEdit: (item: Shift) => void;
  disabled?: boolean;
  editabled?: boolean;
  error?: boolean;
};

function ShiftItem({
  item,
  idx,
  onRemove,
  onEdit,
  disabled = false,
  editabled = true,
  error = false,
}: ShiftItemProps) {
  return (
    <fieldset
      data-test-id={`shift-${idx}`}
      className={
        cx('grid grid-cols-[55px,1fr] w-full text-[15px] border-b border-b-[#d5dadd] py-5 pr-4', {
          'bg-[#FAEFEF]': error,
        })
      }
    >
      <h5
        className={
          'justify-self-center col-start-1 col-end-2 row-start-1 row-end-4 m-0'
        }
      >
        {(idx + 1).toString().padStart(2, '0')}
      </h5>
      <h4
        className={
          'text-[15px] flex justify-between items-center border-b border-b-[#d4d9dc] col-start-2 col-end-6 pb-[5px] mb-2'
        }
      >
        <span data-test-id={'store-name'}>{item.storeName}</span>
        <div className={'flex items-center justify-center'}>
          {error && (
            <div className="px-[6px]">
              <InfoTip
                customIcon={<span className="text-[#be3a3a] text-[14px]"><Warning /></span>}
                info={
                  <section className="w-50">
                    資料未正確，請點擊編輯後，修正紅色提示字欄位內容。
                  </section>
                }
              />
            </div>
          )}
          {editabled && (
            <CustomIconButton
              onClick={() => onRemove(item.id)}
              disabled={disabled}
              data-test-id={'remove-btn'}
              icon="trash"
            />
          )}
          <CustomIconButton
            onClick={() => onEdit(item)}
            data-test-id={'edit-btn'}
            icon="edit"
          />
        </div>
      </h4>
      <div
        className={
          'grid grid-cols[auto,auto,auto,1fr] gap-y-2 gap-x-[25px] mb-0'
        }
      >
        <div>班別工時基準</div>
        <div data-test-id={'base-line'}>{item.baseLine}</div>
        <div>預設班次</div>
        <div data-test-id={'default-shift-schedule-name'}>
          {item.defaultShiftSchedule?.shiftScheduleName}{' '}
        </div>
        <div className="col-start-1 col-end-2">適用班次</div>
        <ul
          className={'m-0 p-0 flex flex-wrap gap-[10px] col-start-2 col-end-5'}
        >
          {item.shiftSchedules?.map(s => (
            <li
              key={s.shiftScheduleId}
              className={
                'inline-block bg-[#353d45] text-white py-[3px] px-[10px]'
              }
            >
              <span data-test-id={'shift-schedule-name'}>
                {s.shiftScheduleName}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </fieldset>
  );
}

export default ShiftItem;
